/* eslint-disable import/no-cycle */
import Http from '@/api/http';
/* eslint-enable import/no-cycle */

/**
 * Schnittstelle zwischen UI und Backend
 */
export default class Validate {
    /**
     * Validates if an email is valid and does not exist in celeraone
     * @param email
     * @returns Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static emailExist(email) {
        return Http.post('/validate/email', {
            email,
        });
    }
}
